import { render, staticRenderFns } from "./WebhookAdmin.vue?vue&type=template&id=ed918438"
import script from "./WebhookAdmin.vue?vue&type=script&lang=js"
export * from "./WebhookAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports